import { getApiUrl } from '@strata-monorepo/utils/_SiteConfig'
import type { IncenseFactoryInstance } from '@redventures/incense/IncenseFactory'

const TEXAS_REGEX = /7([5-9]\d{3}|33\d{2})|885\d{2}/

interface GetStateResponse {
  state: string
}

export default async function getStateByZip(
  zip: string,
  incense?: IncenseFactoryInstance,
  retryCount: number = 3,
): Promise<string | null> {
  try {
    const response = await fetch(`${getApiUrl()}/zipcode/${zip}`, {
      method: 'GET',
    })

    if (!response.ok) {
      throw new Error(`Failed to fetch state data for ZIP code ${zip}`)
    }

    const data: GetStateResponse = (await response.json()) as GetStateResponse
    return data.state
  } catch (exception) {
    const retriesLeft = retryCount - 1

    if (retriesLeft === 0) {
      if (incense) {
        incense(exception)
          .captureDetails({
            name: 'GetStateByZipError',
            message: 'Failed to get state by zip',
          })
          .setSafeData({ zip })
          .sendError()
      }

      // If we've run out of retries, return TX or null based on regex
      return TEXAS_REGEX.test(zip) ? 'TX' : null
    }

    return getStateByZip(zip, incense, retriesLeft)
  }
}
